import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const ContactPickerModal = React.lazy(() => import("./contact-picker.modal"));

const ContactPicker: iModalProps<
  typeof ContactPickerModal,
  {
    onContactSelected: (contactId: string) => any;
    title?: JSX.Element;
    hideAdd?: boolean;
    hideOnSelected?: boolean;
  }
> = {
  name: "contact-picker",
  component: GenerateModalWithSuspense(ContactPickerModal),
};

export default ContactPicker;
